<template>
  <div id="additional-order-modal">
    <loader v-if="isLoading" type="alert" />
    <div v-if="!isLoading">
      <print-options />
      <reference-leaseportal />
      <dealer-accessory-catalog v-if="useNewAccessoryCatalog" />
      <dealer-accessories v-else />
      <div class="total-line">
        <div>{{ i18n.t('/additionalorder/additional order total') }}</div>
        <div class="totals">
          <div>
            {{ i18n.n(quote.Metadata.Prices.DealerAccessoriesTotalPrice.Excl, 'currency') }}
          </div>
          <div>
            {{ i18n.n(quote.Metadata.Prices.DealerAccessoriesTotalPrice.Incl, 'currency') }}
          </div>
        </div>
      </div>
      <quote-remark />
      <proposition-block
        :show-do-not-deliver-before-date="false"
        :show-delivery-date="false"
        :show-expire-date="true"
      ></proposition-block>
      <quote-actions :show-save-button="true" :check-expire-date="true" />
    </div>
  </div>
</template>

<script>
import quoteModule from '@/store/modules/quote'
import QuoteApi from '@/api/server/Quote.api'
import { mapGetters, mapState } from 'vuex'
import PrintOptions from '@/components/generic/presentational/organisms/printOptions/PrintOptions.vue'
import ReferenceLeaseportal from '@/components/generic/presentational/organisms/referenceLeaseportal/ReferenceLeaseportal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import DealerAccessories from '@/components/generic/container/DealerAccessories.vue'
import DealerAccessoryCatalog from '@/components/generic/container/DealerAccessoryCatalog.vue'
import QuoteRemark from '@/components/generic/presentational/molecules/quoteRemark/QuoteRemark.vue'
import QuoteActions from '@/components/generic/presentational/organisms/quoteActions/QuoteActions.vue'
import PropositionBlock from '@/components/generic/presentational/molecules/propositionBlock/PropositionBlock.vue'
import moment from 'moment'

export default {
  components: {
    PrintOptions,
    ReferenceLeaseportal,
    Loader,
    DealerAccessories,
    DealerAccessoryCatalog,
    QuoteRemark,
    QuoteActions,
    PropositionBlock,
  },
  provide() {
    return {
      additionalQuote: true,
    }
  },
  props: {
    childQuoteId: {
      type: String,
      default: null,
    },
  },
  emits: ['close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: true,
      hasError: false,
    }
  },
  computed: {
    ...mapGetters({
      parentQuoteId: 'quote/quoteId',
      deliveryDate: 'additionalQuote/deliveryDate',
      quote: 'additionalQuote/get',
      useNewAccessoryCatalog: 'user/useNewAccessoryCatalog',
    }),
    ...mapState('user', ['dealerSettings']),
  },
  created() {
    this.$store.registerModule('additionalQuote', quoteModule)
    // get child quote if exists
    if (this.childQuoteId) {
      QuoteApi.getQuoteById(this.childQuoteId)
        .then(async (resp) => {
          const quote = resp
          this.$store.dispatch('additionalQuote/loadQuote', quote).then(() => {
            this.isLoading = false
          })
        })
        .catch((e) => {
          this.isLoading = false
          this.onError()
        })
    } else {
      // Create a new child quote
      this.$store.dispatch('additionalQuote/resetQuote')
      const childQuoteDetails = { ...this.$store.getters['quote/quoteDetails'] }
      const emptyQuote = this.$store.getters['additionalQuote/get'].QuoteDetails
      // Clear out properties that should be empty
      childQuoteDetails.DealerAccessories = emptyQuote.DealerAccessories
      childQuoteDetails.ControlCodes = emptyQuote.ControlCodes
      childQuoteDetails.LeaseReference = emptyQuote.LeaseReference
      childQuoteDetails.Remark = emptyQuote.Remark
      childQuoteDetails.ExpireDate = moment
        .utc()
        .add(this.dealerSettings.quoteValidDays, 'days')
        .startOf('day')

      QuoteApi.createChildQuote(this.parentQuoteId, childQuoteDetails)
        .then(async (resp) => {
          const quote = resp.data
          this.$store.dispatch('additionalQuote/loadQuote', quote).then(() => {
            this.$store.dispatch('quote/addChildQuote', quote)
            this.isLoading = false
          })
        })
        .catch((e) => {
          this.isLoading = false
          this.onError()
        })
    }
  },
  unmounted() {
    this.$store.unregisterModule('additionalQuote')
  },
  methods: {
    onError() {
      this.hasError = true
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.referenceLeasePortal) {
  margin-bottom: 1em;
}

.total-line {
  font-weight: 700;
  font-size: 1.4em;
  display: flex;
  justify-content: space-between;

  .totals {
    display: flex;
    div:last-child {
      margin-left: 1em;
    }
  }
  margin-bottom: 2em;
}
</style>
